var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplianceGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#11B50C",
    stroke: "#11B50C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3288 17.5161L8.20491 14.0016C8.08604 13.8677 7.91884 13.7865 7.7401 13.7758C7.56136 13.7652 7.38572 13.826 7.25181 13.9449C7.1179 14.0637 7.0367 14.2309 7.02606 14.4097C7.01543 14.5884 7.07624 14.7641 7.19511 14.898L10.7951 18.948C10.8562 19.0167 10.9307 19.0723 11.0141 19.1112C11.0975 19.1501 11.1879 19.1716 11.2798 19.1743C11.3718 19.177 11.4633 19.1608 11.5488 19.1269C11.6343 19.0929 11.712 19.0418 11.777 18.9768L21.227 9.52676C21.3462 9.39881 21.4111 9.22956 21.4081 9.05469C21.405 8.87982 21.3341 8.71298 21.2105 8.5893C21.0868 8.46563 20.9199 8.39479 20.7451 8.39171C20.5702 8.38862 20.401 8.45353 20.273 8.57276L11.3288 17.5161Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceGreen);
export default __webpack_public_path__ + "static/media/compliance-green.3fd9cd339fbec6d19a98eb8c32e42521.svg";
export { ForwardRef as ReactComponent };